import { NullableString } from "../../../../../../../../types/nullable-types";
import {IServiceFactory} from "../../../../../../../service-factory.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {INuveiCardFieldModel} from "./nuvei-card-field.view-model.interface";
import {INuveiCardHolderFieldViewModel} from "./nuvei-card-holder-field.view-model.interface";
import {scrollElementIntoViewSmooth} from "../../../../../../../../utils/scroll-element-into-view";

export class NuveiCardHolderFieldModel implements INuveiCardFieldModel, INuveiCardHolderFieldViewModel {

    constructor(private readonly services: IServiceFactory) {
        makeObservable<this, '_cardHolderName' | '_isErrorsValidationActive'>(this, {
            _cardHolderName: observable.ref,
            _isErrorsValidationActive: observable.ref
        })
    }

    private _cardHolderName: string = "";

    get cardHolderName(): string {
        return this._cardHolderName;
    }

    get isErrorsValidationActive(): boolean {
        return this._isErrorsValidationActive;
    }

    set cardHolderName(value: string) {
        runInAction(() => {
            this._cardHolderName = value;
            this._isErrorsValidationActive = false;
        })
    }

    focus(): void {
        this._htmlElement?.focus();
        scrollElementIntoViewSmooth(this._htmlElement);
    }

    private _isErrorsValidationActive = false;

    activateValidationErrors(): void {
        runInAction(() => {
            this._isErrorsValidationActive = true;
        });
    }

    get errorMessage(): NullableString {
        if(!this._isErrorsValidationActive) {
            return null;
        }

        if(this._cardHolderName) {
            return null;
        }

        return this.services.language.translate("Required field");
    }

    private _htmlElement: HTMLElement | null = null;

    attach(element: HTMLElement): void {
        this._htmlElement = element;

    }

}